import { InjectedIntl } from 'react-intl'
import { isEmpty, head } from 'lodash'
import { sanitize } from 'dompurify'

import { Attraction, Socials, DividedAttractions } from 'src/interfaces/Attraction'

import {
  ATTRACTIONS_TITLE,
  DEFAULT_SECTION_TITLES,
  SOCIAL_NETWORKS,
  ATTRACTIONS_WIDGETS_SANITIZATION_CONFIG,
} from '../constants'

import locale from './locale'

export const getSocialData = (socials: Socials, key: string) => (
  socials[`${key}_url`]
    ? { key: `${key}_url`, value: socials[`${key}_url`] }
    : { key: `${key}_id`, value: socials[`${key}_id`] }
)

export const getServiceProfileUrl = (service: string, socialPath: string): string => {
  const isURL = service.endsWith('_url')

  if (isURL) return socialPath

  const serviceName = service.split('_')[0]

  return `${SOCIAL_NETWORKS[serviceName].path}${socialPath}`
}

export const getImageURL = (attraction: Attraction): string => {
  const { ticketmasterImageUrl, photos } = attraction

  if (isEmpty(photos)) {
    return ticketmasterImageUrl
  }
  return head(photos).url
}

export const getValidWidget = ({ embeddedWidgetCode }: Attraction): string => sanitize(
  embeddedWidgetCode,
  ATTRACTIONS_WIDGETS_SANITIZATION_CONFIG,
)

export const getModifiedAttractions = (attractions: Attraction[]): DividedAttractions => {
  const sortedAttractions = attractions
    .map(attraction => ({
      ...attraction,
      embeddedWidgetCode: getValidWidget(attraction),
      imageURL: getImageURL(attraction),
    }))
    .sort((a, b) => a.position - b.position)

  const headliners = sortedAttractions.filter(({ starred }) => starred)
  const lineup = sortedAttractions.filter(({ starred }) => !starred)

  return { headliners, lineup }
}

export const getTitle = (
  type: string,
  value: string,
  options: {
    hasLineupAttractions: boolean,
    intl: InjectedIntl,
  },
) => {
  const { ALL, HEADLINERS, LINEUP, MAIN } = ATTRACTIONS_TITLE
  const { hasLineupAttractions, intl: { formatMessage } } = options

  const localeData = locale[value || DEFAULT_SECTION_TITLES[type]]
  const title = localeData ? formatMessage(localeData) : value

  const titles: { [p:string]: string|null } = {
    [ALL]: hasLineupAttractions ? title : null,
    [HEADLINERS]: hasLineupAttractions ? title : null,
    [LINEUP]: title,
    [MAIN]: title,
  }

  return titles[type]
}
